import {
  Activity,
  ArrowDownLeft,
  ArrowUpRight,
  BadgeCheck,
  Banknote,
  BarChart3,
  Bell,
  Boxes,
  Building2,
  CalendarCheck,
  CalendarOff,
  ClipboardCheck,
  Contact,
  Database,
  FileCheck2,
  FileSpreadsheet,
  FileText,
  FolderKanban,
  Gavel,
  HardHat,
  Landmark,
  ListChecks,
  History,
  IdCard,
  IndianRupee,
  LayoutDashboard,
  LifeBuoy,
  PackageCheck,
  PhoneCall,
  PlugZap,
  ReceiptText,
  RefreshCw,
  ScanBarcode,
  Settings,
  Share2,
  ShieldCheck,
  ShoppingCart,
  Sparkles,
  Store,
  Sun,
  Tags,
  Target,
  Truck,
  UserCog,
  Users,
  UsersRound,
  Wallet,
  Warehouse,
  Wrench,
  Zap,
  type LucideIcon,
} from 'lucide-react';

/**
 * The module registry in `@solar/shared` is framework-agnostic and stores icons as
 * names. This is where those names become React components — the one place the
 * shared package's string identifiers meet lucide.
 *
 * Only the icons the registry actually names are imported, so the bundle carries
 * the navigation set rather than the whole library.
 */
const ICONS: Record<string, LucideIcon> = {
  Activity,
  ArrowDownLeft,
  ArrowUpRight,
  BadgeCheck,
  Banknote,
  BarChart3,
  Bell,
  Boxes,
  Building2,
  CalendarCheck,
  CalendarOff,
  ClipboardCheck,
  Contact,
  Database,
  FileCheck2,
  FileSpreadsheet,
  FileText,
  FolderKanban,
  Gavel,
  HardHat,
  Landmark,
  ListChecks,
  History,
  IdCard,
  IndianRupee,
  LayoutDashboard,
  LifeBuoy,
  PackageCheck,
  PhoneCall,
  PlugZap,
  ReceiptText,
  RefreshCw,
  ScanBarcode,
  Settings,
  Share2,
  ShieldCheck,
  ShoppingCart,
  Sparkles,
  Store,
  Sun,
  Tags,
  Target,
  Truck,
  UserCog,
  Users,
  UsersRound,
  Wallet,
  Warehouse,
  Wrench,
  Zap,
};

/** Falls back to a neutral glyph so an unmapped name never crashes the sidebar. */
export const resolveIcon = (name: string): LucideIcon => ICONS[name] ?? LayoutDashboard;
